import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  DEFAULT_PREFERENCES,
  readConsent,
  writeConsent,
} from "./consent";
import { disableAnalytics } from "./analytics";

const CookieConsentContext = createContext(null);

export function CookieConsentProvider({ children }) {
  const [consent, setConsent] = useState(() => readConsent());
  const [preferencesOpen, setPreferencesOpen] = useState(false);

  const preferences = consent || DEFAULT_PREFERENCES;

  const savePreferences = useCallback(
    (nextPreferences) => {
      if (consent?.analytics && !nextPreferences.analytics) {
        disableAnalytics();
      }

      setConsent(writeConsent(nextPreferences));
      setPreferencesOpen(false);
    },
    [consent]
  );

  const value = useMemo(
    () => ({
      consent,
      preferences,
      preferencesOpen,
      openPreferences: () => setPreferencesOpen(true),
      closePreferences: () => setPreferencesOpen(false),
      savePreferences,
    }),
    [consent, preferences, preferencesOpen, savePreferences]
  );

  return (
    <CookieConsentContext.Provider value={value}>
      {children}
    </CookieConsentContext.Provider>
  );
}

CookieConsentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error("useCookieConsent must be used within CookieConsentProvider");
  }
  return context;
};
